import { PilaV } from '@/components/atomos';
import InstructivoCrearNuevaOperacion from './componentes/organismos/InstructivoCrearNuevaOp';
import SobreNosotros from './componentes/organismos/SobreNosotros';
import Beneficios from './componentes/organismos/Beneficios';
import Soporte from './componentes/organismos/Soporte';
import BannerResumenCliente from './componentes/organismos/BannerResumenCliente';

const InicioCliente = () => {
  return (
    <PilaV w={'full'} maxW={'1600px'} spacing="12">
      <BannerResumenCliente />
      <InstructivoCrearNuevaOperacion />
      <SobreNosotros />
      <Beneficios />
      <Soporte />
    </PilaV>
  );
};

export default InicioCliente;
